import type { ReactNode } from 'react'

import { cn } from '@/lib/utils/cn'

import styles from './FormSection.module.css'

interface FormSectionProps {
  title: string
  children: ReactNode
  className?: string
}

/** Groups related fields inside a form, under a small heading. */
export function FormSection({ title, children, className }: FormSectionProps) {
  return (
    <section className={cn(styles.section, className)}>
      <h3 className={styles.title}>{title}</h3>
      {children}
    </section>
  )
}
